// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legislation_parts-module__icon--3G8CP{vertical-align:middle;line-height:inherit;font-size:inherit}\n", ""]);
// Exports
exports.locals = {
	"icon": "legislation_parts-module__icon--3G8CP"
};
module.exports = exports;
